import { makeStyles } from '@material-ui/core/styles';
import { ReactElement } from 'react';

import { colors, spacing } from '../../styling';

export const useStyles = makeStyles({
  container: {
    marginTop: spacing.spacing4x,
    backgroundColor: colors.neloLightGray,
    padding: spacing.spacing2x,
    borderRadius: spacing.spacing1x,
    fontSize: spacing.spacingOneAndHalfx,
    lineHeight: 1.5,
    color: colors.secondaryAccent,
    fontFamily: 'Nunito Sans'
  }
});

interface NeloGrayContainerProps {
  bodyText: string;
}

function NeloGrayContainer(props: NeloGrayContainerProps): ReactElement {
  const classes = useStyles();

  return <div className={`${classes.container}`}>{props.bodyText}</div>;
}

export default NeloGrayContainer;
